import { StatusBar, HomeBar, Wordmark, Check, Button } from "./primitives";
import { PLAN, TONE } from "./data";

export default function S6({ animate = false }) {
  const an = (i, extra = "") => (animate ? { className: `an ${extra}`, style: { "--i": i } } : {});
  const days = ["M", "T", "W", "T", "F", "S", "S"];
  return (
    <div className={`still ${animate ? "animate" : ""}`} data-testid="still-s6" style={{ width: 1080, height: 1920 }}>
      <StatusBar time="6:07" />
      <div style={{ padding: "48px 72px 0" }}><Wordmark size={64} /></div>

      <div {...an(0)} style={{ ...an(0).style, margin: "60px 72px 0", background: "#fff", borderRadius: 32, border: "1px solid var(--ink-06)", padding: "30px 38px", opacity: .75 }}>
        <div style={{ fontSize: 26, color: "var(--ink-40)", letterSpacing: "0.08em", textTransform: "uppercase", fontWeight: 600 }}>Aura suggested a plan</div>
        {PLAN.services.map((s) => (
          <div key={s.name} style={{ display: "flex", gap: 20, marginTop: 18, fontSize: 30 }}>
            <span style={{ width: 130, fontWeight: 600 }}>{s.time}</span>
            <span style={{ flex: 1 }}>{s.name} · {s.provider}</span>
            <span style={{ color: "var(--ink-60)" }}>${s.price}</span>
          </div>
        ))}
        <div style={{ marginTop: 22, fontSize: 28, color: TONE.mint.fg, fontWeight: 600 }}>Accepted ✓</div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 90 }}>
        <div {...an(3, "an-pop")}><Check size={220} /></div>
        <div {...an(4)} className={`serif ${an(4).className || ""}`} style={{ ...an(4).style, fontSize: 96, fontWeight: 500, marginTop: 44, lineHeight: 1 }}>You’re confirmed</div>
        <div {...an(5)} style={{ ...an(5).style, marginTop: 18, fontSize: 34, color: "var(--ink-60)" }}>Tonight at {PLAN.spa} · ${PLAN.total}</div>
      </div>

      <div {...an(6)} style={{ ...an(6).style, margin: "80px 72px 0", background: "#fff", borderRadius: 36, border: "1px solid var(--ink-06)", padding: "36px 40px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 28, color: "var(--ink-60)" }}>
          {days.map((d, i) => <span key={i} style={{ width: 100, textAlign: "center", fontWeight: i === 1 ? 700 : 400, color: i === 1 ? "var(--burgundy)" : "inherit" }}>{d}</span>)}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 14 }}>
          {[9, 10, 11, 12, 13, 14, 15].map((n, i) => (
            <span key={n} style={{ width: 100, height: 100, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 32, fontWeight: 500, background: i === 1 ? "var(--burgundy)" : "transparent", color: i === 1 ? "#fff" : "var(--charcoal)" }}>{n}</span>
          ))}
        </div>
        <div style={{ marginTop: 30, display: "flex", flexDirection: "column", gap: 12 }}>
          {PLAN.services.map((s, i) => (
            <div key={s.name} {...an(8 + i)} style={{ ...an(8 + i).style, display: "flex", gap: 18, alignItems: "center", background: TONE[s.tone].bg, color: TONE[s.tone].fg, borderRadius: 16, padding: "18px 24px", fontSize: 28, fontWeight: 500 }}>
              <span style={{ width: 8, height: 40, borderRadius: 4, background: TONE[s.tone].fg }} />
              <span style={{ width: 130 }}>{s.time}</span>{s.name} · {s.provider}
            </div>
          ))}
        </div>
      </div>

      <div {...an(11)} style={{ ...an(11).style, position: "absolute", left: 72, right: 72, bottom: 110 }}>
        <Button size={34} tone="ghost">Added to your calendar</Button>
      </div>
      <HomeBar />
    </div>
  );
}
